// extracted by mini-css-extract-plugin
module.exports = {"ImageCard":"styles_ImageCard__Lr3VG","withShadow":"styles_withShadow__GMC_b","image":"styles_image__1NopR"};